exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-drawer[data-v-b62332f4]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:50px}.drawer[data-v-b62332f4]{width:50%}", ""]);

// exports
